import { SIDEBAR_LS_KEY } from 'conversations/modules/sidebar/constants'
import { sidebarSettings } from 'conversations/modules/sidebar/selectors'
import { Epic } from 'redux-observable'
import { empty } from 'rxjs'
import { filter, mergeMap } from 'rxjs/operators'
import * as actions from 'shared/store/actions/sidebar'
import { localStore } from 'shared/utils/storage'

import { isActionOf, RootAction, RootState, Services } from 'typesafe-actions'

const sidebarActions = [...Object.values(actions)]

export const sidebarLocalStorage: Epic<RootAction, RootAction, RootState, Services> = (
  action$,
  state
) => {
  return action$.pipe(
    filter(isActionOf(sidebarActions)),
    mergeMap(() => {
      const settings = sidebarSettings(state.value)
      localStore.set(SIDEBAR_LS_KEY, JSON.stringify(settings))
      return empty()
    })
  )
}
